/* ============================================================================
   sticky-bar.js — die Kaufleiste am unteren Rand einblenden
   ----------------------------------------------------------------------------
   Frueher assets/nko-sticky-bar.js (seit M6 umbenannt, Verhalten
   unveraendert). Ersetzt `core.initFixedHeader` aus dem frueheren
   assets/app.js — aber nur den Teil, den die Produktseiten noch brauchen.

   WER DAS LAEDT
   ---------------------------------------------------------------------------
   sections/product.liquid und sections/customizable-product-info.liquid
   (R5). Eine eigene Datei statt eines Teils von assets/product.js, weil der
   Konfigurator dieselbe Leiste hat, aber nicht <nko-product-form>. Vorher
   lud sie ein Gate im Kopf (snippets/head-assets.liquid, nko_produktblaetter).

   WARUM DAS UEBERHAUPT NOETIG IST
   ---------------------------------------------------------------------------
   `.section--minicart` steht `position: fixed` am unteren Rand und ist im
   Grundzustand unsichtbar: `opacity: 0`, `visibility: hidden`,
   `bottom: -20px`. Sichtbar wird sie ausschliesslich durch EINE Regel:

       .js-fixed-header .section--minicart { bottom: 0; opacity: 1; visibility: visible }

   Im Konfigurator blendet section-customizable-product-info.css die Leiste
   unter `.js-fixed-header` erst mit `.mini-show` (configurator.js) ein.
   Ohne diese Datei bleibt der wichtigste Kaufknopf dauerhaft unsichtbar,
   ohne Fehlermeldung.

   WAS ANDERS IST ALS IM LEGACY
   ---------------------------------------------------------------------------
   1. KEIN SCROLL-LISTENER. Das Original las bei JEDEM Scroll-Frame
      `scrollTop` — ein erzwungener Layout-Durchlauf pro Frame. Hier steht ein
      Wachposten bei 200px im Dokument; ein IntersectionObserver meldet sich
      nur, wenn dieser Punkt die Sichtkante KREUZT.
   2. OHNE `js-scroll-top` / `js-scroll-down`. Diese Zustaende nahm in den
      neuen Blaettern niemand mehr ab.

   Die Schwelle von 200px ist aus app.js uebernommen, damit die Leiste an
   derselben Stelle erscheint wie bisher.
   ==========================================================================  */

const SCHWELLE = 200;
const KLASSE = "js-fixed-header";

/* Kein DOMContentLoaded noetig: ein Modul laeuft erst nach dem Parsen, die
   Leiste steht dann schon im Dokument. Laeuft das Modul je URL nur einmal,
   entsteht auch nur ein Wachposten. */
function starte() {
  // Ohne Kaufleiste gibt es nichts einzublenden.
  if (!document.querySelector(".section--minicart")) return;

  /* Der Wachposten ist absolut im Dokument verankert, nicht im Ansichtsfenster:
     `top: 200px` heisst 200px unter dem Seitenanfang. Solange er sichtbar ist,
     steht die Seite oben; sobald er oben hinausgescrollt ist, ist die Schwelle
     ueberschritten. `visibility: hidden` nimmt ihn aus der Darstellung, laesst
     ihm aber seine Box — nur `display: none` wuerde den Beobachter blind
     machen. */
  const posten = document.createElement("div");
  posten.setAttribute("aria-hidden", "true");
  posten.style.cssText =
    "position:absolute;top:" +
    SCHWELLE +
    "px;left:0;width:1px;height:1px;visibility:hidden;pointer-events:none";
  document.body.prepend(posten);

  new IntersectionObserver(([eintrag]) => {
    document.body.classList.toggle(KLASSE, !eintrag.isIntersecting);
  }).observe(posten);
}

starte();

/* ----------------------------------------------------------------------------
   NUR ALS MODUL LADEN: <script src="…" type="module">, nie mit `defer`.
   Der Modulbereich haelt die Namen oben lokal (`starte` gibt es in mehreren
   Theme-Dateien). Module laufen wie `defer` nach dem Parsen in
   Dokumentreihenfolge, aber nur einmal je URL und im strict mode.
   ---------------------------------------------------------------------------- */
